'use strict';

import * as types from '../../types';

export default {
  // デバイス情報を取得
  [types.INITIALIZE_DEVICE_INFO]({commit}){
    commit(types.INITIALIZE_DEVICE_INFO);
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/device/actions.js